<app-load-nav *ngIf="!isPartner()" [activeMenuItem]="'partner-wallet'"></app-load-nav>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>


<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" style="margin-top: 10px;">
  <div fxFlex="100">

    <div>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <ng-container  *ngIf="partnerWallet">
              <h2>
                <ng-container *ngIf="partnerWallet.isClosed">⛔️</ng-container>
                <ng-container *ngIf="!partnerWallet.isClosed">📒</ng-container>
                 {{ partnerWallet.walletNumber }}
                <ng-container *ngIf="partnerWallet.customName"> - {{ partnerWallet.customName }}</ng-container>
                <span style="color: red;" *ngIf="partnerWallet.isClosed"> (closed)️</span>
              </h2>
              <div fxFlex></div>
              <h2 [class.negative_balance]="partnerWallet.balance < 0">
                {{ partnerWallet.balance.formatMoneyWithPlusCcy(partnerWallet.currencyCode)}}
              </h2>
            </ng-container>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
          <div fxFlex="30">
            <div class="list-item" fxLayout="row">
              <label fxFlex="35" class="secondary">Created</label>
              <label fxFlex="65" *ngIf="partnerWallet">{{ this.datePipe.transform(partnerWallet.createDate, "dd.MM.yyy") }}</label>
            </div>
            <div class="list-item" fxLayout="row">
              <label fxFlex="35" class="secondary">Updated</label>
              <label fxFlex="65" *ngIf="partnerWallet">{{ this.datePipe.transform(partnerWallet.updateDate, "dd.MM.yyy") }}</label>
            </div>
            <div class="list-item" fxLayout="row" *ngIf="partnerWallet && partnerWallet.closeDate">
              <label fxFlex="35" class="secondary">Closed</label>
              <label fxFlex="65" *ngIf="partnerWallet">{{ this.datePipe.transform(partnerWallet.closeDate, "dd.MM.yyy") }}</label>
            </div>

            <div class="list-item" fxLayout="row" *ngIf="partnerWallet && partnerWallet.senderFilter">
              <label fxFlex="35" class="secondary">Sender Restriction</label>
              <label fxFlex="65" *ngIf="partnerWallet"><b>{{ partnerWallet.senderFilter }}</b></label>
            </div>

          </div>
          <div fxFlex="30">

            <div class="list-item" fxLayout="row">
              <label fxFlex="35" class="secondary">Wallet Number</label>
              <label fxFlex="65" *ngIf="partnerWallet"><b>{{ partnerWallet.walletNumber }}</b></label>
            </div>

            <ng-container *ngIf="walletLoadInfo">
              <div class="list-item" fxLayout="row">
                <label fxFlex="35" class="secondary">Account Holder</label>
                <label fxFlex="65"><b>{{ walletLoadInfo.accountHolder }}</b></label>
              </div>
              <div class="list-item" fxLayout="row">
                <label fxFlex="35" class="secondary">IBAN</label>
                <label fxFlex="65"><b>{{ walletLoadInfo.iban }}</b></label>
              </div>
              <div class="list-item" fxLayout="row">
                <label fxFlex="35" class="secondary">BIC</label>
                <label fxFlex="65"><b>{{ walletLoadInfo.bic }}</b></label>
              </div>
              <div class="list-item" fxLayout="row">
                <label fxFlex="35" class="secondary">Reference</label>
                <label fxFlex="65" ><b>{{ walletLoadInfo.reference }}</b></label>
              </div>
            </ng-container>

            <ng-container *ngIf="!walletLoadInfo">
              <div class="list-item" fxLayout="row">
                <label fxFlex="35" class="secondary">Wallet IBAN</label>
                <label fxFlex="65" *ngIf="partnerWallet"><b>{{ partnerWallet.walletIban }}</b></label>
              </div>
              <div class="list-item" fxLayout="row">
                <label fxFlex="35" class="secondary">Wallet BIC</label>
                <label fxFlex="65" *ngIf="partnerWallet"><b>{{ partnerWallet.walletBic }}</b></label>
              </div>
              <div class="list-item" fxLayout="row">
                <label fxFlex="35" class="secondary">Reference</label>
                <label fxFlex="65" *ngIf="partnerWallet"><b>{{ partnerWallet.walletBic }}</b></label>
              </div>
            </ng-container>
            <div class="list-item" fxLayout="row">
              <label fxFlex="35" class="secondary">Wallet Name</label>
              <label fxFlex="65" *ngIf="partnerWallet"><b>{{ partnerWallet.customName }}</b></label>
            </div>

          </div>

          <div fxFlex>
            <div style="padding: 20px;">
              <div style="text-align: right; font-size: 3em; font-weight: bold;" *ngIf="partnerWallet">
                <div [class.negative_balance]="partnerWallet.balance < 0">
                  {{partnerWallet.balance.formatMoneyCcy(partnerWallet.currencyCode)}}
                </div>
              </div>
            </div>
          </div>

        </div>

      </mat-expansion-panel>
    </div>
  </div>
</div>

<mat-card>
  <ng-container *ngIf="!isBusy && partnerWallet && !isLoading">

    <div *ngIf="partnerWallet.company" style="font-weight: normal; font-size: 14px; padding-left: 40px;">
      <div>{{ partnerWallet.company.name }}</div>

      <!--<span *ngIf="partnerWallet.revolutAccountId && partnerWallet.walletIban" style="display: inline-block; background-color: yellow; border-radius: 3px; padding: 2px 2px; margin: 2px 0">
      ⚡️Instant Loads via SEPA: {{ partnerWallet.walletIban }}
      </span>-->

      <span *ngIf="walletLoadInfo && walletLoadInfo.iban" style="display: inline-block; background-color: lightskyblue; border-radius: 3px; padding: 2px 2px; margin: 2px 0">
        Loads via SEPA: {{ walletLoadInfo.iban }} Ref. {{ walletLoadInfo.reference }}
      </span>

      <span *ngIf="partnerWallet.brandReferralCode" style="display: inline-block; background-color: lightskyblue; border-radius: 3px; padding: 2px 2px; margin: 2px 0">
        <a [routerLink]="brandReferralUrlLink" style="text-decoration:none">{{ brandReferralUrlLink }}</a>
      </span>


    </div>

    <div fxFlex></div>
    <div  style="text-align: right;">



    <!-- only admin may load -->
    <button [disabled]="isBusy || (partnerWallet && partnerWallet.isClosed)" style="margin-right: 20px;" mat-raised-button color="primary" (click)="loadWallet()" *ngIf="isAdmin()">
      <mat-icon>money</mat-icon> Load Wallet
    </button>

    <!-- only admin and partner may get csv statement -->
    <button [disabled]="isBusy || isPartnerSupport() || (partnerWallet && partnerWallet.isClosed)" style="margin-right: 20px;" mat-raised-button color="primary" (click)="transferFunds()" *ngIf="isAdmin() || isPartner() || isPartnerSupport()">
      <mat-icon>swap_horiz</mat-icon> Transfer Funds
    </button>

    <!-- only admin and partner may get csv statement -->
    <button [disabled]="isBusy || (partnerWallet && partnerWallet.isClosed)" style="margin-right: 20px;" mat-raised-button color="basic" (click)="downloadStatement()" *ngIf="isAdmin() || isPartner() || isWallet()">
      <mat-icon>download</mat-icon> Download Statement
    </button>

    <!-- only admin and partner may upload load file -->
    <button [disabled]="isBusy || isPartnerSupport() || (partnerWallet && partnerWallet.isClosed)" style="margin-right: 20px;" mat-raised-button color="blue" (click)="uploadPartnerLoadsFile()" *ngIf="isAdmin() || isPartner()  || isPartnerSupport() || isFinanceManager() || isComplianceManager()">
      <mat-icon>cloud_upload</mat-icon> Upload Loads file
    </button>

    <!-- only admin may adjust balance -->
    <button [disabled]="isBusy" style="margin-right: 20px;" mat-raised-button color="default" (click)="balanceAdjustment()" *ngIf="isAdmin()">
      <mat-icon style="color: dodgerblue">edit</mat-icon> Balance adjustment
    </button>

    <!-- only admin may edit -->
    <button [disabled]="isBusy" mat-raised-button color="primary" (click)="goToEdit()" *ngIf="isAdmin()">
      <mat-icon>edit</mat-icon> Edit
    </button>
</div>
  </ng-container>

</mat-card>

<div>
  <div fxFlex="100" style="padding-left: 10px; padding-right: 10px;">

    <mat-tab-group>
      <mat-tab label="Transactions">

        <mat-card class="content-card" style="min-height: 500px;">
          <mat-card-title>
            <h5>Transactions</h5>
          </mat-card-title>

          <div fxLayout="row wrap" fxLayoutGap="8px" *ngIf="transactionsTable" fxLayoutAlign="start center">

            <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel"
                           [(ngModel)]="transactionsTable.filters.startFilterDate"></app-date-edit>
            <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel"
                           [(ngModel)]="transactionsTable.filters.endFilterDate"></app-date-edit>

            <mat-form-field class="search-field">
              <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                     [(ngModel)]="transactionsTable.filters.str">
            </mat-form-field>
            <button #searchButton mat-icon-button (click)="onSearch()"
                    [disabled]="startDateFilter.invalid || endDateFilter.invalid">
              <mat-icon>search</mat-icon>
            </button>
            <button mat-icon-button (click)="clearFilter()">
              <mat-icon>clear</mat-icon>
            </button>


          </div>

          <div style="margin: 15px;">



            <app-mat-table-generator #transactionsTable
                                     tableName="transactionsTable"
                                     [useEmbededFilter]="false"
                                     [columns]="transactionsColumns"
                                     [dataSource]="transactionsDataSource"
                                     [editEnabled]="false"
                                     [deleteEnabled]="false"
                                     [multiselectEnabled]="false"
                                     [viewLink]="getTransactionViewLink"
            >
            </app-mat-table-generator>

          </div>

        </mat-card>


      </mat-tab>
      <mat-tab label="Pending Loads" *ngIf="!isWallet()">

        <mat-card class="content-card" *ngIf="partnerWallet" style="min-height: 500px;">
          <mat-card-header>
            <mat-card-title>
              <h5>Pending Card Loads</h5>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div style="margin: 15px;">

              <div class="list-item-header" fxLayout="row" fxLayoutGap="10px" style="font-weight: bold;">
                <div fxFlex="10">Transaction Date</div>
                <div fxFlex="10">Card</div>
                <div fxFlex="5" style="text-align: right">Amount</div>
                <div fxFlex="5" style="text-align: right">Fee</div>
                <div fxFlex="20">Status</div>
                <div fxFlex>Description</div>
                <div fxFlex="20">Documents</div>
              </div>

              <ng-container *ngFor="let cardLoad of pendingCardLoads">

                <div class="list-item" fxLayout="row" fxLayoutGap="10px">
                  <div fxFlex="10">{{cardLoad.createDate | date : 'yyyy-MM-dd HH:mm'}}</div>
                  <div fxFlex="10">{{cardLoad.card.token}}</div>
                  <div fxFlex="5" style="text-align: right">{{cardLoad.amountToLoad.formatMoneyCcy(partnerWallet.currencyCode)}}</div>
                  <div fxFlex="5" style="text-align: right">{{cardLoad.loadFee.formatMoneyCcy(partnerWallet.currencyCode)}}</div>
                  <div fxFlex="20" >
                    <app-load-status-info [bankTransferLoad]="cardLoad.bankTransferLoad"></app-load-status-info>
                    <div *ngIf="cardLoad.bankTransferLoad.isExported">Exported, waiting for confirmation...</div>
                  </div>
                  <div fxFlex>{{ cardLoad.description }}</div>

                  <div fxFlex="20">
                    <ng-container *ngIf="cardLoad.documents && cardLoad.documents.length > 0">
                      <div *ngFor="let doc of cardLoad.documents">

                        <div fxLayout="row" fxLayoutGap="10px">
                          <div fxFlex="5"><mat-icon>attachment</mat-icon></div>
                          <div fxFlex (click)="downloadDocument(doc.id)" style="cursor:pointer;"><small>{{ doc.name }}</small></div>

                          <div fxFlex="10" class="text-right"><mat-icon style="cursor: pointer; color: red;" (click)="deleteDocument(doc.id)">clear</mat-icon></div>
                        </div>


                      </div>
                    </ng-container>
                    <div class="text-right">
                      <button data-tooltip="Upload document" mat-flat-button (click)="uploadDocuments(cardLoad.id)" [disabled]="isBusy">
                        <mat-icon>file_upload</mat-icon>
                      </button>
                    </div>

                  </div>

                </div>

              </ng-container>
            </div>
          </mat-card-content>
        </mat-card>


      </mat-tab>
      <mat-tab label="Users" *ngIf="!isWallet()">
        <mat-card class="content-card" style="min-height: 500px;">
          <mat-card-title>
            <h5>Users</h5>
          </mat-card-title>
          <mat-card-actions align="end">
            <button *ngIf="!isWallet()" [disabled]="isBusy || (partnerWallet && partnerWallet.isClosed)" style="margin-right: 20px;" mat-raised-button color="primary" (click)="inviteUser()">
              Invite user
            </button>
          </mat-card-actions>
          <div *ngIf="partnerWallet && usersDataSource">

            <app-mat-table-generator #usersTable
                                     tableName="usersTable"
                                     [useEmbededFilter]="false"
                                     [columns]="userColumns"
                                     [dataSource]="usersDataSource"
                                     [editEnabled]="false"
                                     [deleteEnabled]="true"
                                     [multiselectEnabled]="false"
                                     [viewLink]="getUserViewLink"
            >
            </app-mat-table-generator>


          </div>

        </mat-card>
      </mat-tab>
    </mat-tab-group>


  </div>
</div>

